// extracted by mini-css-extract-plugin
module.exports = {"amount":"styles_amount__aT8mM","amount__bold":"styles_amount__bold__QUd6J"};